import store from "@/state/store";

export default [
  //login
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
          next();
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  //forgot password
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      },
    },
  },
  //reset password
  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/create-password.vue"),
    meta: {
      title: "Reset Account Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the forgot password page
          next();
        }
      }
    },
  },
  //logout
  {
    path: "/logout",
    name: "logout",
    component: () => import("../views/account/logout.vue"),
    meta: {
      title: "Logout",
      beforeResolve(routeTo, routeFrom, next) {

        localStorage.removeItem("user");
        localStorage.removeItem("userid");
        localStorage.removeItem("jwt");

        next();
      },
    },
  },
  //default dashboard
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
    },
    component: () => import("../views/dashboard/default/index.vue"),
  },
  //client management - client
  {
    path: "/client",
    name: "client",
    meta: {
      title: "Client",
      authRequired: true,
    },
    component: () => import("../views/client/client.vue"),
  },
  //client management - site
  {
    path: "/client/site",
    name: "Site",
    meta: {
      title: "Site",
      authRequired: true,
    },
    component: () => import("../views/client/site.vue"),
  },
  //client management - site qr viewer
  {
    path: "/client/site-qr-viewer",
    name: "Site QR Code Viewer",
    meta: {
      title: "Site QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/site-qr-viewer.vue"),
  },
  //client management - block
  {
    path: "/client/block",
    name: "Block",
    meta: {
      title: "Block",
      authRequired: true,
    },
    component: () => import("../views/client/block.vue"),
  },
  //client management - area
  {
    path: "/client/area",
    name: "Area",
    meta: {
      title: "Area",
      authRequired: true,
    },
    component: () => import("../views/client/area.vue"),
  },
  //client management - location
  {
    path: "/client/location",
    name: "Location",
    meta: {
      title: "Location",
      authRequired: true,
    },
    component: () => import("../views/client/location.vue"),
  },
  //client management - location qr viewer
  {
    path: "/client/location-qr-viewer",
    name: "Room QR Code Viewer",
    meta: {
      title: "Room QR Code Viewer",
      authRequired: true,
    },
    component: () => import("../views/client/location-qr-viewer.vue"),
  },
  //client management - location import & preview
  {
    path: "/client/location-import",
    name: "Room Import & Preview",
    meta: {
      title: "Room Import & Preview",
      authRequired: true,
    },
    component: () => import("../views/client/location-import.vue"),
  },
  //user management - role
  {
    path: "/user/role",
    name: "Role",
    meta: {
      title: "Role",
      authRequired: true,
    },
    component: () => import("../views/user/role.vue"),
  },
  //user management - dormitory
  {
    path: "/user/dormitory",
    name: "Dormitory",
    meta: {
      title: "Dormitory",
      authRequired: true,
    },
    component: () => import("../views/user/dormitory.vue"),
  },
  //user management - team
  {
    path: "/user/team",
    name: "Team",
    meta: {
      title: "Team",
      authRequired: true,
    },
    component: () => import("../views/user/team.vue"),
  },
  //user management - department
  {
    path: "/user/department",
    name: "Department",
    meta: {
      title: "Department",
      authRequired: true,
    },
    component: () => import("../views/user/department.vue"),
  },
  //user management - user
  {
    path: "/user/employee",
    name: "User",
    meta: {
      title: "User",
      authRequired: true,
    },
    component: () => import("../views/user/employee.vue"),
  },
  //pet management - pet cage
  {
    path: "/pet/cage",
    name: "Pet Cage",
    meta: {
      title: "Pet Cage",
      authRequired: true,
    },
    component: () => import("../views/pet/pet-cage.vue"),
  },
  //pet management - pet 
  {
    path: "/pet",
    name: "Pet",
    meta: {
      title: "Pet",
      authRequired: true,
    },
    component: () => import("../views/pet/pet.vue"),
  },
  //pet management - weight 
  {
    path: "/pet/weight",
    name: "Pet Weight",
    meta: {
      title: "Pet Weight",
      authRequired: true,
    },
    component: () => import("../views/pet/weight.vue"),
  },
  //pet management - weight 
  {
    path: "/pet/weight-summary",
    name: "Pet Weight Summary",
    meta: {
      title: "Pet Weight Summary",
      authRequired: true,
    },
    component: () => import("../views/pet/pet-weight-summary.vue"),
  },
  //pet management - pellet consumption 
  {
    path: "/pet/pellet-consumption",
    name: "Pet Pellet Consumption",
    meta: {
      title: "Pet Pellet Consumption",
      authRequired: true,
    },
    component: () => import("../views/pet/pellet-consumption.vue"),
  },
  //pet management - pellet consumption 
  {
    path: "/pet/pellet-consumption-pet-view",
    name: "Pet Pellet Consumption (Pet View)",
    meta: {
      title: "Pet Pellet Consumption (Pet View)",
      authRequired: true,
    },
    component: () => import("../views/pet/pellet-consumption-pet-view.vue"),
  },
  //pet management - mating records
  {
    path: "/pet/mating",
    name: "Pet Mating Records",
    meta: {
      title: "Pet Mating Records",
      authRequired: true,
    },
    component: () => import("../views/pet/mating.vue"),
  },

  //attedance management - attendance listing
  {
    path: "/attendance/listing",
    name: "Attendance",
    meta: {
      title: "Attendance",
      authRequired: true,
    },
    component: () => import("../views/attendance/listing.vue"),
  },
  //attedance management - summary report
  {
    path: "/attendance/summary-report",
    name: "Attendance Summary Report",
    meta: {
      title: "Attendance Summary Report",
      authRequired: true,
    },
    component: () => import("../views/attendance/summary-report.vue"),
  },
  //attedance management - summary report
  {
    path: "/attendance/att-stn-summary",
    name: "Attendance Station Summary",
    meta: {
      title: "Attendance Station Summary",
      authRequired: true,
    },
    component: () => import("../views/attendance/att-stn-summary.vue"),
  },
  //location tracking - records
  {
    path: "/administrative/location-track",
    name: "Location Tracking Records",
    meta: {
      title: "Location Tracking Records",
      authRequired: true,
    },
    component: () => import("../views/administrative/location-track.vue"),
  },
  //room entry - listing
  {
    path: "/room-entry/logs",
    name: "Room Entry Logs",
    meta: {
      title: "Room Entry Logs",
      authRequired: true,
    },
    component: () => import("../views/room-entry/listing.vue"),
  },
  //room entry - summary report
  {
    path: "/room-entry/summary-report",
    name: "Room Entry Summary Report",
    meta: {
      title: "Room Entry Summary Report",
      authRequired: true,
    },
    component: () => import("../views/room-entry/report-viewer.vue"),
  },
  //tvf room access - topic
  {
    path: "/tvf/topic",
    name: "TVF Room Access Topic",
    meta: {
      title: "TVF Room Access Topic",
      authRequired: true,
    },
    component: () => import("../views/tvf-room-access/topic.vue"),
  },
  //tvf room access - logs
  {
    path: "/tvf/logs",
    name: "TVF Room Access Logs",
    meta: {
      title: "TVF Room Access Logs",
      authRequired: true,
    },
    component: () => import("../views/tvf-room-access/logs.vue"),
  },
  //tvf room access - log
  {
    path: "/tvf/log-viewer",
    name: "TVF Room Access Log",
    meta: {
      title: "TVF Room Access Log",
    },
    component: () => import("../views/tvf-room-access/log-viewer.vue"),
  },
  //tvf room access - group
  {
    path: "/tvf/groups",
    name: "TVF Room Access Groups",
    meta: {
      title: "TVF Room Access Groups",
      authRequired: true,
    },
    component: () => import("../views/tvf-room-access/groups.vue"),
  },
  //tvf room access - summary report
  {
    path: "/tvf/summary-report",
    name: "TVF Room Access Summary Report",
    meta: {
      title: "TVF Room Access Summary Report",
      authRequired: true,
    },
    component: () => import("../views/tvf-room-access/summary-report.vue"),
  },
  //toolbox meeting management - topic
  {
    path: "/tm/topic",
    name: "Toolbox Meeting Topic",
    meta: {
      title: "Toolbox Meeting Topic",
      authRequired: true,
    },
    component: () => import("../views/toolbox-meeting/topic.vue"),
  },
  //toolbox meeting management - reports
  {
    path: "/tm/reports",
    name: "Toolbox Meeting Reports",
    meta: {
      title: "Toolbox Meeting Reports",
      authRequired: true,
    },
    component: () => import("../views/toolbox-meeting/reports.vue"),
  },
  //toolbox meeting management - report
  {
    path: "/tm/report",
    name: "Toolbox Meeting Report",
    meta: {
      title: "Toolbox Meeting Report",
      authRequired: false,
    },
    component: () => import("../views/toolbox-meeting/report.vue"),
  },
  //toolbox meeting management - report viewer
  {
    path: "/tm/report-viewer",
    name: "Toolbox Meeting Report",
    meta: {
      title: "Toolbox Meeting Report"
    },
    component: () => import("../views/toolbox-meeting/reportviewer.vue"),
  },
  //equipment management - equipments
  {
    path: "/iv/equipments",
    name: "Equipment Management",
    meta: {
      title: "Equipment Management",
      authRequired: true,
    },
    component: () => import("../views/equipment/listing.vue"),
  },
  //equipment management - import
  {
    path: "/equipment/import",
    name: "Equipment Import",
    meta: {
      title: "Equipment Import",
      authRequired: true,
    },
    component: () => import("../views/equipment/import.vue"),
  },
  //equipment management - SBST assets
  {
    path: "/sbst/assets",
    name: "SBST Assets",
    meta: {
      title: "SBST Assets",
      authRequired: true,
    },
    component: () => import("../views/equipment/sbst-asset.vue"),
  },
  //equipment management - SBST assets
  {
    path: "/sbst/asset-import",
    name: "SBST Asset Import",
    meta: {
      title: "SBST Asset Import",
      authRequired: true,
    },
    component: () => import("../views/equipment/sbst-asset-import.vue"),
  },
  //supplier
  {
    path: "/supplier",
    name: "Supplier",
    meta: {
      title: "Supplier",
      authRequired: true,
    },
    component: () => import("../views/equipment/supplier.vue"),
  },
  //equipment management - monitoring
  {
    path: "/equipment/monitoring",
    name: "Equipment Monitoring",
    meta: {
      title: "Equipment Monitoring",
      authRequired: true,
    },
    component: () => import("../views/equipment/monitoring.vue"),
  },
  //material management - category
  {
    path: "/material/category",
    name: "Material Category",
    meta: {
      title: "Material Category",
      authRequired: true,
    },
    component: () => import("../views/material/category.vue"),
  },
  //material management - sub-category
  {
    path: "/material/subcategory",
    name: "Material Subcategory",
    meta: {
      title: "Material Subcategory",
      authRequired: true,
    },
    component: () => import("../views/material/subcategory.vue"),
  },
  //material management - material
  {
    path: "/material/item",
    name: "Material",
    meta: {
      title: "Material",
      authRequired: true,
    },
    component: () => import("../views/material/material.vue"),
  },
  //material management - material item QR code viewer
  {
    path: "/material/item-viewer",
    name: "Material Item QR Code Viewer",
    meta: {
      title: "Material Item QR Code Viewer"
    },
    component: () => import("../views/material/item-viewer.vue"),
  },
  //material management - import
  {
    path: "/material/import",
    name: "Material Import",
    meta: {
      title: "Material Import",
      authRequired: true,
    },
    component: () => import("../views/material/import.vue"),
  },
  //material management - material orders
  {
    path: "/material/orders",
    name: "Material Orders",
    meta: {
      title: "Material Orders",
      authRequired: true,
    },
    component: () => import("../views/material/orders.vue"),
  },
  //material management - material order viewer
  {
    path: "/material/order-viewer",
    name: "Material Order",
    meta: {
      title: "Material Order"
    },
    component: () => import("../views/material/orderviewer.vue"),
  },
  //material management - approval orders
  {
    path: "/material/orders-approval",
    name: "Pending Approval Orders",
    meta: {
      title: "Pending Approval Orders",
      authRequired: true,
    },
    component: () => import("../views/material/orders-approval.vue"),
  },
  //material management - in pending stock orders
  {
    path: "/material/orders-pending-stock",
    name: "In Pending Stock Orders",
    meta: {
      title: "In Pending Stock Orders",
      authRequired: true,
    },
    component: () => import("../views/material/orders-pending-stock.vue"),
  },
  //material management - in progress / ready orders
  {
    path: "/material/orders-progress-ready",
    name: "Prepare Order Item",
    meta: {
      title: "Prepare Order Item",
      authRequired: true,
    },
    component: () => import("../views/material/orders-progress-ready.vue"),
  },
  //material management - notification group
  {
    path: "/material/notification-group",
    name: "MO Notification Group",
    meta: {
      title: "MO Notification Group",
      authRequired: true,
    },
    component: () => import("../views/material/notification-group.vue"),
  },
  //notification management - email
  {
    path: "/notification/email",
    name: "Email Notification",
    meta: {
      title: "Email Notification",
      authRequired: true,
    },
    component: () => import("../views/notification/email.vue"),
  },
  //courier service - requests
  {
    path: "/courier-service/requests",
    name: "Request Status",
    meta: {
      title: "Request Status",
      authRequired: true,
    },
    component: () => import("../views/courier-service/requests.vue"),
  },
  //courier service - viewer
  {
    path: "/courier-service/viewer",
    name: "Courier Service Viewer",
    meta: {
      title: "Courier Service Viewer"
    },
    component: () => import("../views/courier-service/viewer.vue"),
  },
  //courier service - pending transit
  {
    path: "/courier-service/transit",
    name: "Pending Transit",
    meta: {
      title: "Pending Transit",
      authRequired: true,
    },
    component: () => import("../views/courier-service/transit.vue"),
  },
  //courier service - pending receive
  {
    path: "/courier-service/receive",
    name: "Pending Receive",
    meta: {
      title: "Pending Receive",
      authRequired: true,
    },
    component: () => import("../views/courier-service/receive.vue"),
  },
  //courier service - active monitoring
  {
    path: "/courier-service/active-monitoring",
    name: "Active Monitoring",
    meta: {
      title: "Active Monitoring",
      authRequired: true,
    },
    component: () => import("../views/courier-service/active-monitoring.vue"),
  },
  //courier service - notification group
  {
    path: "/courier-service/notification-group",
    name: "CS Notification Group",
    meta: {
      title: "CS Notification Group",
      authRequired: true,
    },
    component: () => import("../views/courier-service/notification-group.vue"),
  },
  //site survey - reports
  {
    path: "/site-survey/reports",
    name: "Site Survey Reports",
    meta: {
      title: "Site Survey Reports",
      authRequired: true,
    },
    component: () => import("../views/site-survey/reports.vue"),
  },
  //site survey - report viewer
  {
    path: "/site-survey/report-viewer",
    name: "Site Survey Report Viewer",
    meta: {
      title: "Site Survey Report Viewer"
    },
    component: () => import("../views/site-survey/report-viewer.vue"),
  },
  //site work - reports
  {
    path: "/site-work/reports",
    name: "Site Work Reports",
    meta: {
      title: "Site Work Reports",
      authRequired: true,
    },
    component: () => import("../views/site-work/reports.vue"),
  },
  //site work - report viewer
  {
    path: "/site-work/report-viewer",
    name: "Site Work Report Viewer",
    meta: {
      title: "Site Work Report Viewer"
    },
    component: () => import("../views/site-work/report-viewer.vue"),
  },
  //third party - defect reports
  {
    path: "/third-party/defects",
    name: "TP Defect Reports",
    meta: {
      title: "TP Defect Reports",
      authRequired: true,
    },
    component: () => import("../views/third-party/defects.vue"),
  },
  //third party - report viewer
  {
    path: "/third-party/defect-viewer",
    name: "TP Defect Report Viewer",
    meta: {
      title: "TP Defect Report Viewer"
    },
    component: () => import("../views/third-party/defect-viewer.vue"),
  },
  //third party - notification group
  {
    path: "/third-party/notification-group",
    name: "TP Notification Group",
    meta: {
      title: "TP Notification Group",
      authRequired: true,
    },
    component: () => import("../views/third-party/notification-group.vue"),
  },
  //pre check - reports
  {
    path: "/pre-check/reports",
    name: "Pre-Check Reports",
    meta: {
      title: "Pre-Check Reports",
      authRequired: true,
    },
    component: () => import("../views/pre-check/reports.vue"),
  },
  //pre check - report viewer
  {
    path: "/pre-check/report-viewer",
    name: "Pre-Check Report Viewer",
    meta: {
      title: "Pre-Check Report Viewer"
    },
    component: () => import("../views/pre-check/report-viewer.vue"),
  },
  //archive - reports
  {
    path: "/archive/reports",
    name: "Archived Reports",
    meta: {
      title: "Archived Reports",
      authRequired: true,
    },
    component: () => import("../views/administrative/archive-reports.vue"),
  },
  //ePTA records
  {
    path: "/epta/records",
    name: "ePTA Records",
    meta: {
      title: "ePTA Records",
      authRequired: true,
    },
    component: () => import("../views/administrative/epta.vue"),
  },
  //ePTA submission summary
  {
    path: "/epta/summary",
    name: "ePTA Submission Summary",
    meta: {
      title: "ePTA Submission Summary",
      authRequired: true,
    },
    component: () => import("../views/administrative/epta-submission-summary.vue"),
  },
  //sDar records
  {
    path: "/sdar/records",
    name: "eSDAR Records",
    meta: {
      title: "eSDAR Records",
      authRequired: true,
    },
    component: () => import("../views/administrative/sdar.vue"),
  },
  //sDar submission summary
  {
    path: "/sdar/summary",
    name: "eSDAR Submission Summary",
    meta: {
      title: "eSDAR Submission Summary",
      authRequired: true,
    },
    component: () => import("../views/administrative/sdar-application-summary.vue"),
  },
  //sDar user group
  {
    path: "/sdar/user-group",
    name: "eSDAR User Group",
    meta: {
      title: "eSDAR User Group",
      authRequired: true,
    },
    component: () => import("../views/administrative/sdar-user-group.vue"),
  },
  //sbst approval department reminders
  {
    path: "/sbst/reminder",
    name: "SBST Approval Department Reminders",
    meta: {
      title: "SBST Approval Department Reminders",
      authRequired: true,
    },
    component: () => import("../views/administrative/sbst-department-reminders.vue"),
  },
  //sbst approval department reminders
  {
    path: "/sbst/pending-approval",
    name: "SBST Pending Approval Applications",
    meta: {
      title: "SBST Pending Approval Applications",
      authRequired: true,
    },
    component: () => import("../views/administrative/pending-approval-application.vue"),
  },
  //TAR records
  {
    path: "/tar/records",
    name: "TAR Records",
    meta: {
      title: "TAR Records",
      authRequired: true,
    },
    component: () => import("../views/administrative/tar.vue"),
  },
  //TAR notification group
  {
    path: "/tar/notification-group",
    name: "TAR Notification Groups",
    meta: {
      title: "TAR Notification Groups",
      authRequired: true,
    },
    component: () => import("../views/administrative/tar-notification-group.vue"),
  },
  //TAR notification group
  {
    path: "/tar/toa-summary",
    name: "TOA Summary Report",
    meta: {
      title: "TOA Summary Report",
      authRequired: true,
    },
    component: () => import("../views/administrative/toa-summary.vue"),
  },
  //TOA Mainline Protection
  {
    path: "/tar/mainline-protection",
    name: "TOA Mainline Protection",
    meta: {
      title: "TOA Mainline Protection",
    },
    component: () => import("../views/administrative/tar-report.vue"),
  },
  //test scheduler
  {
    path: "/test-scheduler",
    name: "Test Scheduler",
    meta: {
      title: "Test Scheduler",
      authRequired: true,
    },
    component: () => import("../views/administrative/test-scheduler.vue"),
  },

  //site temperature test - reports
  {
    path: "/site-temp/reports",
    name: "Station Temp Test Reports",
    meta: {
      title: "Station Temp Test Reports",
      authRequired: true,
    },
    component: () => import("../views/site-temp/reports.vue"),
  },

  //site temperature test - report viewer
  {
    path: "/site-temp/report-viewer",
    name: "Station Temp Test Report Viewer",
    meta: {
      title: "Station Temp Test Report Viewer"
    },
    component: () => import("../views/site-temp/report-viewer.vue"),
  },

  //location temperature test - reports
  {
    path: "/loc-temp/reports",
    name: "Depot Temp Test Reports",
    meta: {
      title: "Depot Temp Test Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/lsc/loc-temp-reports.vue"),
  },

  //location temperature test - report viewer
  {
    path: "/loc-temp/report-viewer",
    name: "Depot Temp Test Report Viewer",
    meta: {
      title: "Depot Temp Test Report Viewer"
    },
    component: () => import("../views/engineer-checklist/lsc/loc-temp-report-viewer.vue"),
  },

  //engineer checklist - LSC - location temperature summary
  {
    path: "/engineer-checklist/lsc/loc-temp-summary",
    name: "LSC - Depot Temperature Summary",
    meta: {
      title: "LSC - Depot Temperature Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/lsc/loc-temp-summary.vue"),
  },

  //engineer checklist - LSC - site temperature summary
  {
    path: "/engineer-checklist/lsc/temperature-summary",
    name: "LSC - Station Temperature Summary",
    meta: {
      title: "LSC - Station Temperature Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/lsc/temperature-summary.vue"),
  },

  //engineer checklist - NCP - WIT reports
  {
    path: "/engineer-checklist/ncp/wits",
    name: "NCP - (Lab) WIT Reports",
    meta: {
      title: "NCP - (Lab) WIT Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/wits.vue"),
  },

  //engineer checklist - NCP - LBC reports
  {
    path: "/engineer-checklist/ncp/lbcs",
    name: "NCP - (Lab) LBC Reports",
    meta: {
      title: "NCP - (Lab) LBC Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/lbcs.vue"),
  },

  //engineer checklist - NCP - HPC reports
  {
    path: "/engineer-checklist/ncp/hpcs",
    name: "NCP - (Lab) HPC Reports",
    meta: {
      title: "NCP - (Lab) HPC Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/hpcs.vue"),
  },

  //engineer checklist - NCP - pH value summary
  {
    path: "/engineer-checklist/ncp/ph-value-summary",
    name: "NCP - pH Value Summary",
    meta: {
      title: "NCP - pH Value Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/ph-value-summary.vue"),
  },
  //engineer checklist - NCP - Conductivity summary
  {
    path: "/engineer-checklist/ncp/cd-summary",
    name: "NCP - Conductivity Summary",
    meta: {
      title: "NCP - Conductivity Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/cd-summary.vue"),
  },
  //engineer checklist - NCP - Water Sampling Summary
  {
    path: "/engineer-checklist/ncp/ws-summary",
    name: "NCP - Water Sampling Summary",
    meta: {
      title: "NCP - Water Sampling Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/ws-summary.vue"),
  },
  //engineer checklist - NCP - Total Legionella Count Summary
  {
    path: "/engineer-checklist/ncp/lbc-yearly-summary",
    name: "NCP - Total Legionella Count Summary",
    meta: {
      title: "NCP - Total Legionella Count Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/lbc-yearly-summary.vue"),
  },
  //engineer checklist - NCP - Standard Plate Count Summary
  {
    path: "/engineer-checklist/ncp/hpc-yearly-summary",
    name: "NCP - Standard Plate Count Summary",
    meta: {
      title: "NCP - Standard Plate Count Summary",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/hpc-yearly-summary.vue"),
  },

  //engineer checklist - NCP - PM reports
  {
    path: "/engineer-checklist/ncp/pm/reports",
    name: "NCP - PM Reports",
    meta: {
      title: "NCP - PM Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/pm/reports.vue"),
  },
  //engineer checklist - NCP - PM report viewer
  {
    path: "/engineer-checklist/ncp/pm/report-viewer",
    name: "NCP - PM Report Viewer",
    meta: {
      title: "NCP - PM Report Viewer"
    },
    component: () => import("../views/engineer-checklist/ncp/pm/report-viewer.vue"),
  },
  //engineer checklist - NCP - Water sampling reports
  {
    path: "/engineer-checklist/water-sampling-reports/:type",
    name: "NCP - Water Sampling Reports",
    meta: {
      title: "NCP - Water Sampling Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=2"),
  },
  //engineer checklist - NCP - Legionella reports
  {
    path: "/engineer-checklist/legionella-reports/:type",
    name: "NCP - Legionella Reports",
    meta: {
      title: "NCP - Legionella Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=3"),
  },
  //engineer checklist - NCP - Disinfectant reports
  {
    path: "/engineer-checklist/disinfentant-reports/:type",
    name: "NCP - Disinfectant Reports",
    meta: {
      title: "NCP - Disinfectant Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=4"),
  },
  //engineer checklist - NCP - Cyclone filter reports
  {
    path: "/engineer-checklist/cyclone-filter-reports/:type",
    name: "NCP - Cyclone Filter Reports",
    meta: {
      title: "NCP - Cyclone Filter Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=5"),
  },
  //engineer checklist - NCP - Chamber reports
  {
    path: "/engineer-checklist/chamber-reports/:type",
    name: "NCP - Chamber Reports",
    meta: {
      title: "NCP - Chamber Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=6"),
  },
  //engineer checklist - NCP reports
  {
    path: "/engineer-checklist/ncp/ncp-reports",
    name: "NCP Reports",
    meta: {
      title: "NCP Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/ncp/ncp-reports"),
  },
  //engineer checklist - report viewer
  {
    path: "/engineer-checklist/report-viewer",
    name: "Engineer Report Viewer",
    meta: {
      title: "Engineer Report Viewer"
    },
    component: () => import("../views/engineer-checklist/engineer-report-viewer.vue"),
  },
  //engineer checklist - WCC reports
  {
    path: "/engineer-checklist/wcc/wcc-reports",
    name: "WCC Reports",
    meta: {
      title: "WCC Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/wcc/wcc-reports"),
  },
  //engineer checklist - WCC - Preventive Maintenance Reports
  {
    path: "/engineer-checklist/pm-reports/:type",
    name: "WCC - Preventive Maintenance Reports",
    meta: {
      title: "WCC - Preventive Maintenance Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=8"),
  },
  //engineer checklist - WCC - Annual Shutdown Service Reports
  {
    path: "/engineer-checklist/tbc-reports/:type",
    name: "WCC - Annual Shutdown Reports",
    meta: {
      title: "WCC - Annual Shutdown Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=9"),
  },
  //engineer checklist - WCC - Oil & Gas Filter Change Reports
  {
    path: "/engineer-checklist/og-reports/:type",
    name: "WCC - Oil & Gas Filter Change Reports",
    meta: {
      title: "WCC - Oil & Gas Filter Change Reports",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/engineer-reports.vue?typeId=10"),
  },
  //engineer checklist - Site Checklist Assigns
  {
    path: "/engineer-checklist/site-checklist-assign",
    name: "Site Checklist Assigns",
    meta: {
      title: "Site Checklist Assigns",
      authRequired: true,
    },
    component: () => import("../views/engineer-checklist/site-checklist-assign.vue"),
  },
  //supplier checklist - Site Checklist Assigns
  {
    path: "/supplier/site-checklist-assign",
    name: "Supplier Site Checklist Assigns",
    meta: {
      title: "Supplier Site Checklist Assigns",
      authRequired: true,
    },
    component: () => import("../views/supplier/site-checklist-assign.vue"),
  },
  //supplier checklist - WCC - Preventive Maintenance Reports
  {
    path: "/supplier/pm-reports/:type",
    name: "WCC - Supplier PM Reports",
    meta: {
      title: "WCC - Supplier PM Reports",
      authRequired: true,
    },
    component: () => import("../views/supplier/reports.vue?typeId=8"),
  },
  //supplier checklist - report viewer
  {
    path: "/supplier/report-viewer",
    name: "Supplier Report Viewer",
    meta: {
      title: "Supplier Report Viewer"
    },
    component: () => import("../views/supplier/report-viewer.vue"),
  },
    //supplier checklist - WCC flushing records
  {
    path: "/supplier/wcc/flushing-records",
    name: "Supplier WCC Flushing Records",
    meta: {
      title: "Supplier WCC Flushing Records",
      authRequired: true,
    },
    component: () => import("../views/supplier/flushing-records.vue"),
  },
  //supplier checklist - WCC flushing summary
  {
    path: "/supplier/wcc/flushing-summary",
    name: "Supplier Flushing Summary",
    meta: {
      title: "Supplier Flushing Summary",
      authRequired: true,
    },
    component: () => import("../views/supplier/flushing-summary.vue"),
  },
  //supplier checklist - chiller flushing report
  {
    path: "/supplier/wcc/chiller-flushing-report",
    name: "Supplier Chiller Flushing Report",
    meta: {
      title: "Supplier Chiller Flushing Report"
    },
    component: () => import("../views/supplier/chiller-flushing-report.vue"),
  },
  //corrective maintenance - cases
  {
    path: "/cm/case/cases",
    name: "CM Cases",
    meta: {
      title: "CM Cases",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/cases.vue"),
  },
  //corrective maintenance - pending cases only
  {
    path: "/cm/case/pending-cases/:status",
    name: "CM Pending Cases",
    meta: {
      title: "CM Pending Cases",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/cases.vue?status=Pending"),
  },
  //corrective maintenance - in progress cases only
  {
    path: "/cm/case/in-progress-cases/:status",
    name: "CM In Progress Cases",
    meta: {
      title: "CM In Progress Cases",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/cases.vue?status=In Progress"),
  },
  //corrective maintenance - completed cases only
  {
    path: "/cm/case/completed-cases/:status",
    name: "CM Completed Cases",
    meta: {
      title: "CM Completed Cases",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/cases.vue?status=Completed"),
  },
  //corrective maintenance - case viewer
  {
    path: "/cm/case/case-viewer",
    name: "CM Case Viewer",
    meta: {
      title: "CM Case Viewer"
    },
    component: () => import("../views/corrective-maintenance/case/case-viewer.vue"),
  },
  //corrective maintenance - reports
  {
    path: "/cm/report/reports",
    name: "CM Follow-up Reports",
    meta: {
      title: "CM Follow-up Reports",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/report/reports.vue"),
  },
  //corrective maintenance - case viewer
  {
    path: "/cm/report/report-viewer",
    name: "CM Follow-up Report Viewer",
    meta: {
      title: "CM Follow-up Report Viewer"
    },
    component: () => import("../views/corrective-maintenance/report/report-viewer.vue"),
  },
  //corrective maintenance - teams
  {
    path: "/cm/teams",
    name: "CM Teams",
    meta: {
      title: "CM Teams",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/teams.vue"),
  },
  //corrective maintenance - sor
  {
    path: "/cm/sor",
    name: "CM SOR Setting",
    meta: {
      title: "CM SOR Setting",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/sor.vue"),
  },
  //corrective maintenance - sor import
  {
    path: "/cm/sor-import",
    name: "CM SOR Setting Import",
    meta: {
      title: "CM SOR Setting Import",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/sor-import.vue"),
  },
  //corrective maintenance - sor completed cases
  {
    path: "/cm/case/part-replacement",
    name: "CM SOR Part Replacement",
    meta: {
      title: "CM SOR Part Replacement",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/part-replacement.vue"),
  },
  //corrective maintenance - part replacement summary
  {
    path: "/cm/case/part-replacement-summary",
    name: "CM SOR Part Replacement Summary",
    meta: {
      title: "CM SOR Part Replacement Summary",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/case/part-replacement-summary.vue"),
  },
  //corrective maintenance - supplier appintments
  {
    path: "/cm/supplier-appointments",
    name: "Supplier Appointments",
    meta: {
      title: "Supplier Appointments",
      authRequired: true,
    },
    component: () => import("../views/event/events.vue"),
  },
  //corrective maintenance - supplier case appintments - active
  {
    path: "/event/supplier-appts",
    name: "All On-Site Supplier Cases",
    meta: {
      title: "All On-Site Supplier Cases",
      authRequired: true,
    },
    component: () => import("../views/event/supplier-appts.vue"),
  },
  //corrective maintenance - active pending schedule cases only
  {
    path: "/event/pending-supplier-appts/:status",
    name: "Active On-Site Supplier Cases",
    meta: {
      title: "Active On-Site Supplier Cases",
      authRequired: true,
    },
    component: () => import("../views/event/supplier-appts.vue?status=Active"),
  },
  //corrective maintenance - in progress schedule cases only
  {
    path: "/event/in-progress-supplier-appts/:status",
    name: "In Progress On-Site Supplier Cases",
    meta: {
      title: "In Progress On-Site Supplier Cases",
      authRequired: true,
    },
    component: () => import("../views/event/supplier-appts.vue?status=In Progress"),
  },
  //corrective maintenance - completed on site supplier cases only
  {
    path: "/event/completed-supplier-appts/:status",
    name: "Completed On-Site Supplier Cases",
    meta: {
      title: "Completed On-Site Supplier Cases",
      authRequired: true,
    },
    component: () => import("../views/event/supplier-appts.vue?status=Completed"),
  },
   //corrective maintenance  - notification group
  {
    path: "/cm/notification-group",
    name: "CM Notification Group",
    meta: {
      title: "CM Notification Group",
      authRequired: true,
    },
    component: () => import("../views/corrective-maintenance/notification-group.vue"),
  },
  //fault call - new fault call validation
  {
    path: "/fault-call/validation",
    name: "New Fault Call Validation",
    meta: {
      title: "New Fault Validation",
      authRequired: false,
    },
    component: () => import("../views/fault-call/new-fault-call-validation.vue"),
  },
  //fault call - new fault call form
  {
    path: "/fault-call/new",
    name: "New Fault Call",
    meta: {
      title: "New Fault",
      authRequired: false,
    },
    component: () => import("../views/fault-call/new-fault-call.vue"),
  },
  //fault call - acknowledgement
  {
    path: "/fault-call/acknowledge",
    name: "Fault Call Acknowledgement",
    meta: {
      title: "Fault Call Acknowledgement",
      authRequired: false,
    },
    component: () => import("../views/fault-call/acknowledge.vue"),
  },
  //fault call - all records
  {
    path: "/fault-call/records",
    name: "Fault Call Records",
    meta: {
      title: "Fault Call Records",
      authRequired: true,
    },
    component: () => import("../views/fault-call/records.vue"),
  },
  
  //fault call - open records only
  {
    path: "/fault-call/open-records/:status",
    name: "Fault Call (Open) Records",
    meta: {
      title: "Fault Call (Open) Records",
      authRequired: true,
    },
    component: () => import("../views/fault-call/records.vue?status=Open"),
  },
  //fault call - in progress records only
  {
    path: "/fault-call/in-progress-records/:status",
    name: "Fault Call (In Progress) Records",
    meta: {
      title: "Fault Call (In Progress) Records",
      authRequired: true,
    },
    component: () => import("../views/fault-call/records.vue?status=In Progress"),
  },
  //fault call - closed records only
  {
    path: "/fault-call/closed-records/:status",
    name: "Fault Call (Closed) Records",
    meta: {
      title: "Fault Call (Closed) Records",
      authRequired: true,
    },
    component: () => import("../views/fault-call/records.vue?status=Closed"),
  },
  //fault call - weekly call back chronological table
  {
    path: "/fault-call/weekly-call-back-summary",
    name: "Weekly Call Back Choreological Table",
    meta: {
      title: "Weekly Call Back Choreological Table",
      authRequired: true,
    },
    component: () => import("../views/fault-call/weekly-call-back-summary.vue"),
  },
  //fault call - yearly ecs call back fault summary
  {
    path: "/fault-call/yearly-call-back-summary",
    name: "ECS Call Back Fault Summary",
    meta: {
      title: "ECS Call Back Fault Summary",
      authRequired: true,
    },
    component: () => import("../views/fault-call/yearly-call-back-summary.vue"),
  },
  //fault call - record viewer
  {
    path: "/fault-call/viewer",
    name: "Fault Call Record Viewer",
    meta: {
      title: "Fault Call Record Viewer",
      authRequired: false,
    },
    component: () => import("../views/fault-call/record-viewer.vue"),
  },
  //fault call - type
  {
    path: "/fault-call/type",
    name: "Fault Call Type",
    meta: {
      title: "Fault Call Type",
      authRequired: true,
    },
    component: () => import("../views/fault-call/type.vue"),
  },
  //fault call - subtype
  {
    path: "/fault-call/subtype",
    name: "Fault Call Subtype",
    meta: {
      title: "Fault Call Subtype",
      authRequired: true,
    },
    component: () => import("../views/fault-call/subtype.vue"),
  },
  //fault call - notification group
  {
    path: "/fault-call/notification-group",
    name: "Fault Call Notification Group",
    meta: {
      title: "Fault Call Notification Group",
      authRequired: true,
    },
    component: () => import("../views/fault-call/notification-group.vue"),
  },
  //fault call - email recipients
  {
    path: "/fault-call/email-notification",
    name: "Fault Call Email Notification",
    meta: {
      title: "Fault Call Email Notification",
      authRequired: true,
    },
    component: () => import("../views/fault-call/email-notification.vue"),
  },
  //fault call - qr code site listing
  {
    path: "/fault-call/qr-code",
    name: "Fault Call QR Code",
    meta: {
      title: "Fault Call QR Code",
      authRequired: true,
    },
    component: () => import("../views/fault-call/fault-qr.vue"),
  },
  //fault call - qr code room listing
  {
    path: "/fault-call/qr-code-room",
    name: "Fault Call QR Code (Room)",
    meta: {
      title: "Fault Call QR Code (Room)",
      authRequired: true,
    },
    component: () => import("../views/fault-call/fault-qr-room.vue"),
  },
  //fault call - qr code site viewer
  {
    path: "/fault-call/qr-code-viewer",
    name: "Fault Call QR Code Viewer",
    meta: {
      title: "Fault Call QR Code Viewer",
      authRequired: false,
    },
    component: () => import("../views/fault-call/fault-qr-viewer.vue"),
  },
  //work schedule - scheduler
  {
    path: "/scheduler",
    name: "Scheduler",
    meta: {
      title: "Scheduler",
      authRequired: true,
    },
    component: () => import("../views/scheduler/scheduler.vue"),
  },
  //work schedule - mobile view scheduler
  {
    path: "/mobile-view-scheduler",
    name: "Scheduler Mobile View",
    meta: {
      title: "Scheduler Mobile View",
    },
    component: () => import("../views/scheduler/mobile-view-scheduler.vue"),
  },
  //work schedule - summary scheduler
  {
    path: "/scheduler/summary",
    name: "Scheduler Summary",
    meta: {
      title: "Scheduler Summary",
    },
    component: () => import("../views/scheduler/summary-report.vue"),
  },
  //work schedule - task items
  {
    path: "/scheduler/task-item",
    name: "Scheduler Task Items",
    meta: {
      title: "Scheduler Task Items",
      authRequired: true,
    },
    component: () => import("../views/scheduler/task-item.vue"),
  },
  //work schedule - email recipients
  {
    path: "/scheduler/email-notification",
    name: "Scheduler Email Notification",
    meta: {
      title: "Scheduler Email Notification",
      authRequired: true,
    },
    component: () => import("../views/scheduler/email-notification.vue"),
  },
  {
    path: "/main-calendar",
    name: "main-calendar",
    meta: { title: "Calendar", authRequired: true },
    component: () => import("../views/calendar/main"),
  },
  //work schedule - public holiday
  {
    path: "/public-holiday",
    name: "Public Holiday Setting",
    meta: {
      title: "Public Holiday Setting",
      authRequired: true,
    },
    component: () => import("../views/scheduler/public-holiday.vue"),
  },
  //work schedule - Engineer Scheduler
  {
    path: "/engineer/scheduler",
    name: "Engineer Scheduler",
    meta: {
      title: "Engineer Scheduler",
      authRequired: true,
    },
    component: () => import("../views/engineer-scheduler/scheduler.vue"),
  },
  //work schedule - Engineer Team
  {
    path: "/engineer/team",
    name: "Engineer Team",
    meta: {
      title: "Engineer Team",
      authRequired: true,
    },
    component: () => import("../views/engineer-scheduler/team.vue"),
  },
  //work schedule - Engineer Job Scope
  {
    path: "/engineer/job-scope",
    name: "Engineer Job Scope",
    meta: {
      title: "Engineer Job Scope",
      authRequired: true,
    },
    component: () => import("../views/engineer-scheduler/job-scope.vue"),
  },
  //PM - reports
  {
    path: "/pm/reports",
    name: "PM Reports",
    meta: {
      title: "PM Reports",
      authRequired: true,
    },
    component: () => import("../views/preventive-maintenance/reports.vue"),
  },
  //PM - report viewer
  {
    path: "/pm/viewer",
    name: "PM Report Viewer",
    meta: {
      title: "PM Report Viewer",
      authRequired: false,
    },
    component: () => import("../views/preventive-maintenance/report-viewer.vue"),
  },
  {
    path: "/coming-soon",
    name: "Coming Soon",
    meta: {
      title: "Coming Soon",
      authRequired: true,
    },
    component: () => import("../views/pages/coming-soon.vue"),
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404"
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/:catchAll(.*)',
    name: '404',
    meta: {
      title: "Error 404",
    },
    component: () => import('../views/auth/errors/404-basic')
  },
];